export default () => ({
  root: {
    borderRight: '1px solid #e3e6e9',
    flexGrow: 0,
  },
});
